(() => {
  const form = document.querySelector('#ov-real-product-form');
  if (!form) return;
  const picker = form.querySelector('[name="id"]');
  const cards = [...document.querySelectorAll('.pack[data-count]')];
  const status = document.querySelector('#ov-releasit-status');
  const money = price => new Intl.NumberFormat('es-CL', {style:'currency', currency:'CLP', maximumFractionDigits:0}).format(price);
  const quantity = form.querySelector('[name="quantity"]');
  let selectedCount = '2';
  let pendingCount = null;
  let pendingUntil = 0;
  let applyingOffer = false;
  let retryTimer;
  const paint = () => {
    const selected = cards.find(card => card.dataset.count === selectedCount);
    if (!selected) return;
    cards.forEach(card => card.setAttribute('aria-pressed', String(card === selected)));
    document.querySelectorAll('[data-selected-count]').forEach(el => el.textContent = selectedCount);
    document.querySelectorAll('[data-selected-price]').forEach(el => el.textContent = money(Number(selected.dataset.price)));
  };
  const choose = count => {
    if (!cards.some(card => card.dataset.count === String(count))) return;
    selectedCount = String(count);
    if (picker.options.length > 1) {
      const option = [...picker.options].find(option => option.dataset.count === selectedCount);
      if (option) {picker.value = option.value; picker.dispatchEvent(new Event('change', {bubbles:true}));}
      quantity.value = '1';
    } else {quantity.value = selectedCount;}
    quantity.dispatchEvent(new Event('change', {bubbles:true}));
    paint();
  };
  const chooseInForm = () => {
    clearTimeout(retryTimer);
    if (!pendingCount || Date.now() > pendingUntil) {pendingCount = null; return;}
    const offer = [...document.querySelectorAll('._rsi-quantity-offers-offer-container')].find(el => el.getClientRects().length && el.querySelector('._rsi-quantity-offers-title')?.textContent.trim().match(/^\d+/)?.[0] === pendingCount);
    if (offer && !offer.classList.contains('_rsi-quantity-offers-selected')) {
      applyingOffer = true;
      offer.querySelector('._rsi-quantity-offers-offer')?.click();
      applyingOffer = false;
    }
    if (offer?.classList.contains('_rsi-quantity-offers-selected')) {pendingCount = null; return;}
    retryTimer = setTimeout(chooseInForm, 150);
  };
  const syncOnOpen = () => {pendingCount = selectedCount; pendingUntil = Date.now() + 10000; requestAnimationFrame(chooseInForm);};
  const enhance = () => {
    const button = document.querySelector('#ov-releasit-mount ._rsi-buy-now-button');
    if (button && !button.dataset.ovConnected) {
      button.dataset.ovConnected = 'true';
      for (const [key,value] of Object.entries({background:'linear-gradient(130deg,#2c6848,#103b29)','border-radius':'14px',padding:'14px 18px','font-size':'16px','min-height':'58px'})) button.style.setProperty(key,value,'important');
      button.setAttribute('role','button'); button.setAttribute('tabindex','0');
      button.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();button.click();}});
    }
  };
  cards.forEach(card => card.addEventListener('click', () => choose(card.dataset.count)));
  picker.addEventListener('change', paint);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-order],[data-mc-order],a.bx-button[href="#mc-order"],.hero-copy>a[href="#mc-order"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.mcQuantity) choose(button.dataset.mcQuantity);
    const nativeButton = document.querySelector('#ov-releasit-mount ._rsi-buy-now-button');
    if (nativeButton) {
      status.hidden = true;
      setTimeout(() => {syncOnOpen(); nativeButton.click();}, 0);
    } else {
      status.hidden = false;
      form.scrollIntoView({behavior:'smooth', block:'center'});
    }
  }, true);
  document.addEventListener('click',event=>{
    if(event.target.closest('#ov-releasit-mount ._rsi-buy-now-button')) syncOnOpen();
    const offer=event.target.closest('._rsi-quantity-offers-offer-container');
    if(offer && !applyingOffer){pendingCount=null;const count=offer.querySelector('._rsi-quantity-offers-title')?.textContent.trim().match(/^\d+/)?.[0];if(count) choose(count);}
  },true);
  const observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1))) {enhance();if(pendingCount) chooseInForm();}});
  observer.observe(document.body,{childList:true,subtree:true});
  choose(selectedCount); enhance();
})();
